import styled from 'styled-components';

export const CollectRequestContainer = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #d58500;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CollectRequestTitle = styled.p`
  margin-right: 24px;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
`;
